import { defineStyle as r, defineStyleConfig as e } from "@chakra-ui/styled-system";
const o = r({
  borderColor: "inherit"
}), t = r({
  borderStyle: "solid"
}), d = r({
  borderStyle: "dashed"
}), i = r({
  borderStyle: "solid",
  borderColor: "onPrimary.layoutHelper"
}), a = r({
  borderStyle: "solid",
  borderColor: "onSurface.layoutHelper"
}), s = {
  solid: t,
  light: i,
  dark: a,
  dashed: d
}, l = {
  s: r({
    borderWidth: "1px"
  }),
  m: r({
    borderWidth: "2px"
  }),
  l: r({
    borderWidth: "3px"
  })
}, b = e({
  baseStyle: o,
  variants: s,
  sizes: l,
  defaultProps: {
    variant: "dark",
    size: "s"
  }
});
export {
  b as dividerTheme
};
